export default "__VITE_ASSET__X06yKdp0__"